/*
* @描述: 编辑商机
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2024-12-06 09:25:34
*/
<template>
    <el-dialog :before-close="handleDialogClose"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               :visible.sync="dialogVisible"
               class="custom_form_dialog custom-form-dialog"
               title="编辑商机"
               width="600px">
        <div v-loading="loading" class="custom_form_body">
            <CustomFormPc v-if="dataLoaded&&formInfoList.length"
                          @submit-form="submitProjectFormData"
                          :field_list="formInfoList"
                          :form_detail="projectFormData"
                          :is_release="projectFormData.is_release"
                          ref="projectForm"
                          :field_form="'projects'"
                          :pk_id="project_id"/>
            <div v-if="projectStageFormShow">
                <div class="page_little_title">
                    <span class="title">阶段任务字段</span>
                </div>
                <CustomFormPc ref="projectStageForm"
                              :field_list="projectStageFormFields"
                              @submit-form="submitProjectStageFormData">
                </CustomFormPc>
            </div>
            <div class="add_approval_select_process">
                <approveProcessSelect ref="approveProcessSelectRef"
                                      :approval_node_list="approval_node_list">
                </approveProcessSelect>
            </div>
        </div>
        <div slot="footer">
            <el-button @click="handleDialogClose">取消</el-button>
            <el-button v-if="is_release===0" plain type="primary" @click="handleDialogSave">保存</el-button>
            <el-button type="primary" @click="handleDialogConfirm">发布</el-button>
        </div>
    </el-dialog>
</template>
<script>
import CustomFormPc from "@/components/pComponents/CustomFormPc";
import {getApprovalNodes, getFormFields, projectAdd, projectDetail, projectEdit} from "@/api";
import approveProcessSelect from "@/components/pComponents/approveProcessSelect";
import {getBusinessIsApproval} from "@/utils";

export default {
    name: "BusinessEdit",
    data() {
        return {
            formInfoList: [],
            projectFormData: {},
            dataLoaded: false,
            projectStageFormFields: [],
            projectStageFormData: {},
            isApproval: 0,
            is_release: 1,
            approval_node_list: [],
            loading: false,
            projectStageFormShow: false,
        }
    },
    props: {
        dialogVisible: {
            type: Boolean,
            default: false,
        },
        project_id: {
            type: Number,
            default: 0,
        },
    },
    components: {CustomFormPc, approveProcessSelect},
    created() {
        this._getFromFields()
    },
    methods: {
        _getFromFields() {
            this.loading = true
            getFormFields({
                field_form: 'projects'
            }).then(res => {
                if (res.code === 200) {
                    this.formInfoList = res.data
                    getBusinessIsApproval('project_add').then(res => {
                        this.isApproval = res
                        if (this.isApproval === 1) {
                            getApprovalNodes({
                                approval_type: 'project_add',
                            }).then(res => {
                                if (res.code === 200) {
                                    this.approval_node_list = res.data
                                    this.$refs.approveProcessSelectRef.set_approval_node_list(res.data)
                                }
                                this.loading = false
                            }).catch(() => {
                                this.loading = false
                            })
                        }
                    })
                    this.getBusinessDetail()
                } else {
                    this.loading = false
                }
            }).catch(() => {
                this.loading = false
            })
        },

        //获取商机详情
        getBusinessDetail() {
            this.loading = true
            projectDetail({
                project_id: this.project_id
            }).then(res => {
                if (res.code === 200) {
                    this.projectFormData = res.data
                    this.is_release = res.data.is_release
                    this.dataLoaded = true
                }
                this.loading = false
            })
        },

        // 关闭弹窗
        handleDialogClose() {
            this.$emit('update:dialogVisible', false)
        },

        //获取商机表单数据
        submitProjectFormData(data) {
            if (this.isApproval === 1 && !this.$refs.approveProcessSelectRef.handleClickPublish()) return false
            this.projectFormData = {
                ...data,
                is_release: this.is_release,
                project_id: this.project_id,
                node_list: this.approval_node_list
            }
            projectEdit(this.projectFormData).then(res => {
                if (res.code === 200) {
                    this.$toast.success('编辑成功')
                    this.$emit('update:dialogVisible', false)
                    this.$emit('refresh-list')
                }
            })
        },

        //获取商机阶段表单数据
        submitProjectStageFormData(data) {
            if (this.isApproval === 1 && !this.$refs.approveProcessSelectRef.handleClickPublish()) return false
            this.projectFormData = {
                ...this.projectFormData,
                is_release: this.is_release,
                ...data,
                project_id: this.project_id,
                node_list: this.approval_node_list
            }
            projectEdit(this.projectFormData).then(res => {
                if (res.code === 200) {
                    this.$toast.success('编辑成功')
                    this.$emit('update:dialogVisible', false)
                    this.$emit('refresh-list')
                }
            })
        },

        handleDialogSave() {
            this.is_release = 0
            this.$refs.projectForm.handleClickPublish(false)
        },

        // 确定
        handleDialogConfirm() {
            this.is_release = 1
            this.$refs.projectForm.handleClickPublish()
        },
    },
}
</script>
<style lang="scss" scoped>
.custom_form_body {
    max-height: 490px;
    padding: 24px;
}
</style>